import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {Translate} from 'react-localize-redux';
import SlickSlider from "react-slick";
import {Loading} from "../components/Layout";
import background from "../images/bg_schuttrange_contact.png";
import qrcode from "../images/schuttrange_contact_qr.png";

const ContactWrapper = styled.div`
    height: 100%;
    overflow-y: auto;
`;

const ContactBlock = styled.div`
    margin: 50px;
    display: flex;
    justify-content: space-between;
    height: 55%;
`;

const Left = styled.div`
    float: left;
    border: none;
    border-collapse: collapse;
    width: 85%;
    margin-bottom: ${props => props.theme.scale * 22}px;
    font-size: 23px;
    font-family: 'MuseoSans-300';

`;

const Right = styled.div`
    float: right;
    width: 15%;
`;

const Title = styled.h1`
   font-family: 'MuseoSans-700';
   font-size: 30px;
   color: black;
`;

const TextBlock = styled.div`
    margin-bottom: 25px;
`;

const InformationTable = styled.table`
    border: none;
    border-collapse: collapse;
    width: 80%;
    margin-bottom: ${props => props.theme.scale * 22}px;

    td {
        padding: 0;
    }
`;

const QrCodeBlock = styled.div`
    border: none;
    border-collapse: collapse;
    margin-bottom: ${props => props.theme.scale * 22}px;
    width: 100%;
    right: 0px;
`;

const QrCodeImage = styled.img`
    border: none;
    border-collapse: collapse;
    width: 100%;
    right: 0px;
`;

const QrCodeText = styled.div`
    width: 100%;
    text-transform: uppercase;
    text-align: center;
    font-size: 15px;
    font-family: 'MuseoSans-300';
    color: ${props => props.theme.shade2};
`;

const BackgroundImage = styled.img`

        backgroundSize: 'cover',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        left: 0,
        zIndex: 1,
`

const Contacts = () => {

    const menu = useSelector(state => state.data.Contacts);
    const theme = useSelector(state => state.config.theme);
    const layout = useSelector((state) => state.config.layout);
    const customer = useSelector((state) => state.config.customer);
    const dispatch = useDispatch();

        let output = "";

        if (customer === "schuttrange"){

            output = (
                <>
                    <ContactBlock>
                        <Left>
                            <Title><Translate id={"contacts.contactus"} /></Title>
                            <TextBlock>
                                Commune de Schuttrange<br/>
                                2 Place de l'Eglise<br/>
                                L-5367 Schuttrange<br/>
                            </TextBlock>
                            <TextBlock>
                                Centrale téléphonique<br/>
                                Tél. +352 35 01 13 - 1<br/>
                                Fax. +352 35 01 13 - 259<br/>
                            </TextBlock>
                            <TextBlock>
                                Secrétariat Communal<br/>
                                Tél. +352 35 01 13 - 220<br/>
                                Email commune@schuttrange.lu<br/>
                            </TextBlock>

                            <Title><Translate id={"contacts.openinghours"} /></Title>
                            <Translate id={"contacts.monday"} /> 08:00-11:30 et 13:00-16:00<br/>
                            <Translate id={"contacts.tuesday"} /> 08:00-11:30 et 13:00-16:00 (16:00-18:30 <Translate id={"contacts.appointment"} />)<br/>
                            <Translate id={"contacts.wednesday"} /> 08:00-11:30 et 13:00-16:00<br/>
                            <Translate id={"contacts.thursday"} /> 08:00-11:30 et 13:00-16:00<br/>
                            <Translate id={"contacts.friday"} /> 08:00-14:00 (07:00-08:00 <Translate id={"contacts.appointment"} />)<br/>
                        </Left>

                        <Right>
                            <QrCodeBlock>
                                <QrCodeImage src={qrcode}></QrCodeImage>
                                <QrCodeText><Translate id={"contacts.bookappointement"} /></QrCodeText>
                            </QrCodeBlock>
                        </Right>
                    </ContactBlock>
                    <BackgroundImage src={background}></BackgroundImage>
                </>
            );
        }
        else{
            output = (
                <ContactBlock>
                </ContactBlock>
            );
        }

 //   return <ContactWrapper style={style}>{output}</ContactWrapper>;
    return <ContactWrapper>{output}</ContactWrapper>;
};

export default Contacts;